import SellersRepository from 'client-sdk/src/Repository/sellers-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  CREATE_SELLER,
  CREATE_SELLER_FAILED,
  CREATE_SELLER_SUCCESS,
  GET_SELLERS,
  GET_SELLERS_FAILED,
  GET_SELLERS_SUCCESS,
  UPDATE_SELLER_STATUS,
  UPDATE_SELLER_STATUS_FAILED,
  UPDATE_SELLER_STATUS_SUCCESS,
} from './constants';

import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* getSellers(actions: any): unknown {
  try {
    const {response, count, activeCardCount, inactiveCardCount} =
      yield SellersRepository.getSellers(actions);
    yield put({
      type: GET_SELLERS_SUCCESS,
      data: response.data,
      count: count.data,
      activeCardCount: activeCardCount.data,
      inactiveCardCount: inactiveCardCount.data,
    });
  } catch (error) {
    yield put({
      type: GET_SELLERS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* updateSellerStatus(actions: any): unknown {
  try {
    const {pagination} = actions.payload;
    yield SellersRepository.updateSellerStatus(actions);
    yield put({
      type: UPDATE_SELLER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_SELLERS,
      payload: {...pagination, sort: 'id,desc'},
    });
    handleNotfication('وضعیت فروشنده با موفقیت تغییر پیدا کرد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_SELLER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* createSeller(actions: any): unknown {
  try {
    const {pagination, callback} = actions.payload;
    yield SellersRepository.createSeller(actions);
    yield put({
      type: CREATE_SELLER_SUCCESS,
    });
    yield put({
      type: GET_SELLERS,
      payload: {...pagination, sort: 'id,desc'},
    });
    callback();
    handleNotfication('فروشنده با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_SELLER_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export default function* sellerSaga() {
  yield takeLatest(GET_SELLERS, getSellers);
  yield takeLatest(UPDATE_SELLER_STATUS, updateSellerStatus);
  yield takeLatest(CREATE_SELLER, createSeller);
}
